import {
  createOrganizationRequestSchema,
  createOrganizationResponseSchema,
  messageBalanceBlockedJobsResponseSchema,
  organizationDetailsSchema,
  organizationMessageBalanceResponseSchema,
  organizationUsageResponseSchema,
  systemSettingsResponseSchema,
  updateOrganizationRequestSchema,
  type CreateOrganizationResponse,
  type MessageBalanceBlockedJobsResponse,
  type MessageBalanceDiscardBlockedJobsRequest,
  type MessageBalanceResumeBlockedJobsRequest,
  type OrganizationDetails,
  type OrganizationMessageBalanceResponse,
  type OrganizationUsageResponse,
  type SystemSettingsResponse,
  type UpdateOrganizationRequest,
} from "@multi-chat/shared";
import { apiGet, apiPatch, apiPost } from "./client.js";

export async function createOrganization(
  name: string,
  signal?: AbortSignal,
): Promise<CreateOrganizationResponse> {
  const body = createOrganizationRequestSchema.parse({ name });
  return createOrganizationResponseSchema.parse(
    await apiPost("/organizations", body, signal),
  );
}

export async function getSupportContact(signal?: AbortSignal): Promise<SystemSettingsResponse> {
  return systemSettingsResponseSchema.parse(await apiGet("/support-contact", signal));
}

export async function getOrganization(
  organizationId: number,
  signal?: AbortSignal,
): Promise<OrganizationDetails> {
  return organizationDetailsSchema.parse(
    await apiGet(`/organizations/${organizationId}`, signal),
  );
}

export async function getOrganizationUsage(
  organizationId: number,
  signal?: AbortSignal,
): Promise<OrganizationUsageResponse> {
  return organizationUsageResponseSchema.parse(
    await apiGet(`/organizations/${organizationId}/usage`, signal),
  );
}

export async function updateOrganization(
  organizationId: number,
  body: UpdateOrganizationRequest,
  signal?: AbortSignal,
): Promise<OrganizationDetails> {
  const parsed = updateOrganizationRequestSchema.parse(body);
  return organizationDetailsSchema.parse(
    await apiPatch(`/organizations/${organizationId}`, parsed, signal),
  );
}

export async function getOrganizationMessageBalance(
  organizationId: number,
  signal?: AbortSignal,
): Promise<OrganizationMessageBalanceResponse> {
  return organizationMessageBalanceResponseSchema.parse(
    await apiGet(`/organizations/${organizationId}/message-balance`, signal),
  );
}

export async function getOrganizationBlockedJobs(
  organizationId: number,
  signal?: AbortSignal,
): Promise<MessageBalanceBlockedJobsResponse> {
  return messageBalanceBlockedJobsResponseSchema.parse(
    await apiGet(`/organizations/${organizationId}/message-balance/blocked-jobs`, signal),
  );
}

export async function resumeOrganizationBlockedJobs(
  organizationId: number,
  payload: MessageBalanceResumeBlockedJobsRequest,
  signal?: AbortSignal,
): Promise<{ success: true }> {
  return apiPost(`/organizations/${organizationId}/message-balance/blocked-jobs/resume`, payload, signal);
}

export async function discardOrganizationBlockedJobs(
  organizationId: number,
  payload: MessageBalanceDiscardBlockedJobsRequest,
  signal?: AbortSignal,
): Promise<{ success: true }> {
  return apiPost(`/organizations/${organizationId}/message-balance/blocked-jobs/discard`, payload, signal);
}
